module.exports = __webpack_public_path__ + "media/pro/TriangleTop-fff8e46c.svg";